import dayjs from 'dayjs';
import 'dayjs/locale/en'; // preload some expected locales
import 'dayjs/locale/fr'; // preload some expected locales
import localizedFormat from 'dayjs/plugin/localizedFormat'; // Import plugin for localized date formats
import './en-int'; // Import the custom locale
import utc from 'dayjs/plugin/utc';

const locales = ['en', 'fr', 'en-int'];

// Set the locale based on the user's preferences (e.g., from Accept-Language header)
const userLocale = (navigator?.language ?? '').split('-')[0];
const locale = locales.includes(userLocale) ? userLocale : 'en-int'; // Default to 'en-int' if not found

dayjs.locale(locale);
dayjs.extend(localizedFormat);
dayjs.extend(utc);

if (import.meta.env.MODE === 'development') {
  console.info('Dayjs extendeed with localizedFormat and utc');
  console.info('Day.js locale set to:', locale);
}

export default dayjs;
